import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';

class CouponInfo extends Component {
  thecourse = decodeURI(window.location.href.split('/')[4]);
  coupon = decodeURI(window.location.href.split('/')[5]);
    state = {  myform:{} } 

    handleSubmit = (e)=>{
      e.preventDefault();
      const baseURL = `https://auth.`+process.env.REACT_APP_BACKEND+`/auth/forgotpassword` ; //"http://localhost:8001/auth/login/" ; //
      
     //const {course,info, more} = this.state.myform;
      // const { groupingmap} = this.state
      var data = {...this.state.myform};
  
      console.log("see me",baseURL,data);
      axios.post(baseURL,data,{headers: {
      }}
        ).then((response) => {
        console.log(response);
        
       
       
         toast(response.data.success);
        window.location.href = '/resetpassword'
    
      }).catch((e)=>{
        console.log(e.response);
        // window.location.href = '/'
        if(e.response.data['error']){
          toast(e.response.data['error']);
        }else{
          for (let a in e.response.data){
            toast(e.response.data[a.toString()][0]);
            console.log(e.response.data[a.toString()][0]);
           }
        }
        
         
      });
  
      // console.log(name,password);
    }
    handleinput= (e)=>{
      const myform = {...this.state.myform};
      myform[e.target.name] = e.target.value;
      this.setState({myform},()=>{console.log(this.state.myform)});
      
    }
  

    render() { 
      
        return (
            <React.Fragment>
             <div>
       
        <ToastContainer />
      </div>
                <section className="showcase mt-2">
    <section className="p-5">
        <div className="container shadow-lg rounded bg-white px-5">
            <p className="pere text-secondary fs-3 text-warning pt-4 px-3 fw-bold">Free Licence Coupon Generated</p>
            <div className="row g-3 text-secondary">
                <div className="col-md-5 p-4">
                  Coupon has been generated for <b>{this.thecourse}</b>
                  <br/>
                  Coupon code: <b>{this.coupon}</b>
                  <div>

                    <h1>How to use coupon</h1>

                  <h5>To Generate Course Licences</h5>
                     <p> Course licences are tokens/codes given to people as permission to let them register.
                      It is impossible to register for a course without a licence.
                      </p>
                      To generate licences for your course:
                      <ol>
                      <li className='coupon'>Visit <a href="https://shop.varsityreghub.com" target="_blank">https://shop.varsityreghub.com </a> </li>
                      <li className='coupon'>Search for your course name.</li>
                      <li className='coupon'>Click on the product with the same name as your course.</li>
                      <li className='coupon'>Add <b>500</b> units of the product to your cart and checkout.</li>
                      <li className='coupon'>Apply the coupon code <b>{this.coupon}</b> to get the licence codes for free at 100% discount. </li>
                      <li className='coupon'>After purchasing the product for free, check your orders to see the <b>500</b> licence codes attached
                      to your order.</li>
                      <li className='coupon'>Distribute the codes to the students you want to register for your course. </li>
                      </ol>
                  {/* Go back Home */}
                  </div>
                  <div className="course mt-5">
                  <a  href="/listcourses"><button  className="btn btn-info btn-lg  text-white fw-bold">I have written the coupon code somewhere</button> </a>
                  </div>
                </div>
                <div className="col-md-2">
                </div>
                <div className="col-md-5">
                <img className="recruit img-fluid w-75 d-none d-sm-block mb-2" src="/images/casual-life-3d-recruiter-woman-having-online-interview.png"/>
                </div>
              </div>
              </div>
              </section>
              </section>
              
            </React.Fragment>
        );
    }
}
 
export default CouponInfo;